var WooAccount = {
	init:function(){
    console.log('Wesh la miff');
		$(".btn-register").on("click touchend", function(e){
			if(e.type == 'touchend'){
				$(this).off("click");
			}

			WooAccount.switchToRegister();
		});
		$(".btn-edit-mdp").on("click touchend", function(e){
			if(e.type == "touchend"){
				$(this).off("click");
			}
			if($(".Myaccount-box").hasClass("open")){
				$(".Myaccount-box").removeClass("open");
				$(".Myaccount-box").css({height:0});
			}else{
				$(".Myaccount-box").addClass("open");
				$(".Myaccount-box").css({height:$(".Myaccount-box .content").height()});
			}
		})
		$(".retour span").on("click touchend", function(e){
			if(e.type == 'touchend'){
				$(this).off("click");
			}


			WooAccount.switchToLogin();
		});
	},

	switchToRegister:function(){
		$(".register-container").addClass("visible");
		$(".woocommerce-form-login").addClass("hidden");
		$(".new-client-container").addClass("hidden");
		$(".btn-register").addClass("hidden");
	},
	switchToLogin:function(){

    $(".register-container").removeClass("visible");
    $(".new-client-container").removeClass("hidden");
		$(".woocommerce-form-login").removeClass("hidden");
		$(".btn-register").removeClass("hidden");
	}


}

$(window).load(function(){
	if($(".woocommerce-account").length){
		WooAccount.init();
	}
})
